export default __webpack_public_path__ + "static/media/Q20_3_resized.6e61b49b.jpg";